import "@/style.css";
import "@fontsource/barlow"; // Defaults to weight 400
import "@fontsource/barlow/300.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow/700.css"; // bold
import "@fontsource/barlow/400-italic.css"; // Specify weight and style
import "@fontsource/montserrat";
import "@fontsource/montserrat/800.css";
import "@fontsource/montserrat/900.css"; // Specify weight
import "@fontsource/montserrat/400-italic.css"; // Specify weight and style

import App from "@/App.vue";
import pinia from "@/store.js";
import { i18n } from "./i18n";
import router from "@/router.js";
import { createApp } from "vue";
import VueGtag from "vue-gtag";
import { metaTagPlugin } from "@m-media/vue3-meta-tags";
import VueSmoothScroll from "vue3-smooth-scroll";
import { config, isLocal } from "./config";
import { xs2eventPlugin } from "@xs2event/js-lib/plugins";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { setLocale } from "@xs2event/js-lib/util";

const app = createApp(App);
app.use(i18n);
app.use(pinia);
app.use(VueQueryPlugin, {
  enableDevtoolsV6Plugin: true,
});
app.use(VueSmoothScroll);

app.use(xs2eventPlugin, {
  development: isLocal,
  sentryDsn: config.SENTRY_DSN,
  appName: config.WEBAPP,
  version: config.VERSION,
  apiPath: config.API_URL,
  cdnPath: config.CDN_URL,
  strapiUrl: config.STRAPI_API_URL,
});

app.use(
  metaTagPlugin,
  {
    defaultName: window.location.href,
    defaultLocale: i18n.global.locale.value,
    locales: ["en_GB"],
    preconnect: [config.CDN_URL, config.API_URL],
  },
  router
);

app.use(VueGtag, {
  config: { id: "UA-151465471-1" },
  router,
  enabled: true,
});
app.provide("gtag", app.config.globalProperties.$gtag);

app.use(router);

setLocale(localStorage.AcceptedLanguage || "en").then((r) => {});

app.mount("#app");
